import type { ImageLoaderProps } from 'next/image';

import { calmLogger } from './calmLogger';

export const calmLoader = ({ src, width: _width }: ImageLoaderProps): string => {
	const width = Math.floor(_width);
	const parsedSrc = new URL(src);
	const pathnamePieces = parsedSrc.pathname.split('/');
	if (pathnamePieces.length === 3) {
		const transformPath = pathnamePieces[1];
		const srcWidthString = transformPath.split('x')[0];
		try {
			// the calm assets service will upsize images,
			// so we have to take the Math.min ourselves client-side
			const srcWidth = parseInt(srcWidthString, 10);
			pathnamePieces[1] = `${Math.min(srcWidth, width)}`;
		} catch (err) {
			calmLogger.warn('Attempted to transform an unrecognized assets.calm.com url', { src });
		}
	} else {
		pathnamePieces.splice(1, 0, `${width}`);
	}
	parsedSrc.pathname = pathnamePieces.join('/');
	return parsedSrc.toString();
};
